import { CardBulletedOutline, HomeOutline, Magnify, SlotMachineOutline } from '@patrianna-icons/material-icons'
import type { ComponentType } from 'react'

import ShopMobileLink from 'src/containers/Menu/ShopMobileLink'
import { useAppSelector } from 'src/store/hooks'
import { getActiveCurrencyIdSelector } from 'store/modules/currencies/selectors'
import { isLoggedInSelector } from 'store/modules/user/selectors'
import bottomNavigation from 'temp/bottomNavigation.json'

type LoggedPath = {
  loggedIn: string
  loggedOut: string
}

type CurrencyPath = {
  SC: string
  GC: string
}

type LinkItem = {
  id: string
  icon: keyof typeof Icons
  path?: LoggedPath | CurrencyPath | string
  label?: string
}

const Icons: Record<string, ComponentType<any>> = {
  HomeOutline,
  SlotMachineOutline,
  Magnify,
  CardBulletedOutline,
  ShopMobileLink,
}

const linksArray = bottomNavigation as LinkItem[]

function isLoggedPath(path: CurrencyPath | LoggedPath | string): path is LoggedPath {
  return (path as LoggedPath)?.loggedIn !== undefined
}

function isCurrencyPath(path: CurrencyPath | LoggedPath | string): path is CurrencyPath {
  return (path as CurrencyPath)?.SC !== undefined
}

const useMobileBottomNavigation = () => {
  const loggedIn = useAppSelector(isLoggedInSelector)
  const activeCurrency = useAppSelector(getActiveCurrencyIdSelector)

  return linksArray.map((item) => {
    const temp = Object.assign({}, item) as LinkItem & { path?: string }

    if (isLoggedPath(item.path)) {
      temp.path = loggedIn ? item.path.loggedIn : item.path.loggedOut
    }

    if (isCurrencyPath(item.path)) {
      temp.path = item.path[activeCurrency]
    }

    return {
      ...temp,
      icon: Icons[item.icon],
    }
  })
}

export default useMobileBottomNavigation
